// extracted by mini-css-extract-plugin
export var equalColumn = "_hx-0";